<template>
  <div class="form-card">
    <div class="form-card__header">
      <h6 class="form-card__title">
        <i class="bi bi-sliders"></i>
        Caracteristicas y Opciones
      </h6>
    </div>
    <div class="form-card__body">
      <div class="d-flex flex-column">
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.elecbilling" type="checkbox" class="mr-2">
          Habilitar Facturacion Electronica
        </label>

        <label class="d-inline-flex align-items-start mb-1">
          <input v-model="newbo_options.use_own_afip_certificates" type="checkbox" class="mr-2 mt-1">
          <span>
            Usa su propio certificado para webservice AFIP
            <span v-if="cuit && certificatesExist !== true" class="text-muted">
              <br>
              (Debe cargar los cerificados desde la pestaña General)
            </span>
          </span>
        </label>

        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.showbarcodes" type="checkbox" class="mr-2">
          Habilitar búsqueda por código en punto de venta
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.allow_inventories" type="checkbox" class="mr-2">
          Habilitar los movimientos de stock
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.allow_sale_without_stock" type="checkbox" class="mr-2">
          Permitir realizar ventas sin stock
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.allow_price_edit" type="checkbox" class="mr-2">
          Permitir cambio de precios en venta
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.allow_purchases" type="checkbox" class="mr-2">
          Habilitar modulo compras
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.print_bill" type="checkbox" class="mr-2">
          Imprimir comprobantes por cada acción que se realice
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.print_bill_ticket" type="checkbox" class="mr-2">
          Imprimir ticket en ventas
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.print_receipt_ticket" type="checkbox" class="mr-2">
          Imprimir ticket en Recibos
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.print_ordernote_ticket" type="checkbox" class="mr-2">
          Imprimir ticket en Ordenes de pedido
        </label>
        <!-- <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.send_email" type="checkbox" class="mr-2">
          Enviar factura al email
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.send_email_atm" type="checkbox" :disabled="bo_options.send_email!==true" class="mr-2">
          Enviar factura al email automaticamente
        </label> -->
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.use_prodimage" type="checkbox" class="mr-2">
          Habilitar uso de imágenes en los productos
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.salesclerk_module" type="checkbox" class="mr-2">
          Habilitar modulo de vendedores
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.use_catalogs" type="checkbox" class="mr-2">
          Habilitar catálogos de productos
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.alert_stock" type="checkbox" class="mr-2">
          Mostrar alertas por falta de stock
        </label>
        <label class="d-inline-flex align-items-center mb-1">
          <input v-model="newbo_options.discount_each_line" type="checkbox" class="mr-2">
          Habilitar descuentos individuales por producto
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['bo_options','cuit'],
  data: function() {
    return {
      newbo_options: {},
      certificatesExist: null, // null = no consultado, true/false = resultado
      cuitChecked: false,      // indica que ya hubo una consulta tras cambio de cuit
    }
  },
  watch: {
    'newbo_options.send_email': {
      handler: function() {
        this.newbo_options.send_email_atm = (this.newbo_options.send_email==0) ? 0 : this.newbo_options.send_email_atm;
      }
    },
   cuit: {
     immediate: true,
     handler(newVal) {
      
      const digits = newVal ? String(newVal).replace(/\D/g, '') : '';
         console.log('CUIT changed to:', newVal, 'digits:', digits);

        if (!digits || digits.length !== 11) {
          console.log('CUIT is invalid, resetting state.');
         this.certificatesExist = null;
        this.cuitChecked = false;
        return;
      }

   

       this.cuitChecked = false;
       this.certificatesExist = null;
       const vm = this;
       vm.$http.post('/api/configs/existe-afip-certificates', { cuit: digits })
         .then((response) => {
           vm.certificatesExist = response.data && response.data.existe === true;
           vm.cuitChecked = true;
         })
         .catch(() => {
           vm.certificatesExist = null;
           vm.cuitChecked = true;
         });
     }
   }    
  },
  mounted: function () {
    this.newbo_options = this.bo_options;
  },
  methods: {
    
  }
}
</script>
